import React from "react";
import ReactDOM from "react-dom/client";
import { SuperadminConsole } from "./SuperadminConsole";
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <SuperadminConsole />
  </React.StrictMode>,
);